module.exports = __webpack_public_path__ + "8909bc2f8e7e1074b02423dc6623dc2c.svg";